import { Breadcrumb, Col, Row, Spin, Tabs, Typography } from "antd";
import { FaRegCalendar, FaRegCalendarCheck, FaRegClock, FaRegFileAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import moment from "moment";

import CardInformacao from "../../components/CardInformacao";
import { stateGlobal } from "../../../../interfaces/Global";
import { useGerenciar } from "./useGerenciar";

const SolicitacoesDeAtivacaoGerenciar: React.FC = () => {

    const propsState = useSelector((state: stateGlobal) => state.global);

    const {
        onClickTab,
        activeKeyTabs,
        solicitacao,
        tabs,
        onClickVoltarListagem,
        valueDataConclusao,
        isLoadingSolicitacao,
    } = useGerenciar();

    return (
        <Spin
            spinning={isLoadingSolicitacao}
        >
            <Row
                gutter={[6, 12]}
            >
                <Col
                    xs={24}
                    lg={7}
                    xl={7}
                    span={7}
                >
                    <Typography.Title level={3} style={{ marginBottom: 0 }}>
                        {'Solicitação de Ativação'}
                    </Typography.Title>

                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <a
                                onClick={onClickVoltarListagem}
                            >
                                {'Solicitações de Ativação'}
                            </a>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>{'Solicitação de Ativação'}</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>

                <Col
                    xs={24}
                    lg={17}
                    xl={17}
                    span={17}
                >
                    <Row gutter={[8, 8]}>
                        <Col
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={8}
                            span={8}
                        >
                            <CardInformacao
                                IconComponent={FaRegFileAlt}
                                title="CONTRATO"
                                value={solicitacao?.contrato.nome || "--"}
                            />
                        </Col>

                        <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={8}
                            span={8}
                        >
                            <CardInformacao
                                IconComponent={FaRegCalendar}
                                title="DATA DE SOLICITAÇÂO"
                                value={solicitacao?.createdAt ? moment(solicitacao?.createdAt).format('DD/MM/YYYY HH:mm') : '--'}
                            />
                        </Col>

                        <Col
                            xs={24}
                            sm={12}
                            md={12}
                            lg={12}
                            xl={8}
                            span={8}
                        >
                            <CardInformacao
                                IconComponent={valueDataConclusao ? FaRegCalendarCheck : FaRegClock}
                                title="DATA DE CONCLUSÃO"
                                value={valueDataConclusao ? moment(valueDataConclusao).format('DD/MM/YYYY HH:mm') : "--"}
                                iconBackgroundColor={valueDataConclusao ? propsState.theme === 'light' ? '#d6f9e6' : '#18432E' : undefined}
                                iconColor={valueDataConclusao ? "#00B153" : undefined}
                            />
                        </Col>
                    </Row>
                </Col>

                <Col
                    span={24}
                    style={{
                    }}
                >
                    <Tabs
                        activeKey={activeKeyTabs}
                        onChange={onClickTab}
                        defaultActiveKey="1"
                        type="card"
                        style={{ width: "100%", marginTop: 15 }}
                        tabBarStyle={{ marginBottom: 0 }}
                        key={"tabsSolicitacoesAtivacao"}
                    >
                        {tabs.map((tab) => {
                            return (
                                <Tabs.TabPane
                                    key={tab.key}
                                    tab={tab.label}
                                    disabled={tab.disabled}
                                    style={{
                                        borderRadius: 4
                                    }}
                                >
                                    {tab.children}
                                </Tabs.TabPane>
                            )
                        })}
                    </Tabs>
                </Col>
            </Row>
        </Spin>
    )
}

export default SolicitacoesDeAtivacaoGerenciar;
